var alignment_rtlignore_default = {
  "alignLeft": "JtdWm",
  "textWrapNowrap": "xfJTp",
  "alignRight": "IdeX4",
  "alignCenter": "GPih5",
  "sizeFullWidth": "MzssH",
  "renderedInTable": "_9cBfa",
  "sizeOriginal": "eQaCh",
  "sizeContent": "VzJaO",
  "sizeSmall": "LcQuv",
  "sizeSmallCenter": "DAl-w",
  "flex": "_8VHbW",
  "LEFT": "YUVmI",
  "CENTER": "WmTdT",
  "RIGHT": "JejQh",
  "AUTO": "PuKmT",
  "JUSTIFY": "-oSrG"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
